import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AudienceService } from 'app/library/audience/services/audience.service';
import { MaxBrainScheduledStreamContent } from 'app/library/scheduled-stream-content/models/scheduled-stream-content.model';

@Component({
    selector: 'app-engage-schedule-featured-content-dialog',
    templateUrl: './engage-schedule-featured-content-dialog.component.html',
    styleUrls: ['./engage-schedule-featured-content-dialog.component.scss'],
})
export class EngageScheduleFeaturedContentDialogComponent implements OnInit {
    @Input()
    scss: MaxBrainScheduledStreamContent;

    @Input()
    postId: string;

    @Input()
    postName: string;

    @Input()
    minDate: Date;

    @Input()
    maxDate: Date;

    @Input()
    isNew: string;

    selectedMinDate: Date;
    showEndDate: boolean = false;

    updateEndDate(): void {
        const startDate = this._formGroup.get('startDate').value;

        this.minDate = startDate ? new Date(startDate) : null;
    }

    updateStartDate(): void {
        const endDate = new Date(this._formGroup.get('endDate').value);

        this.maxDate = endDate ? new Date(endDate) : null;
    }

    get priority() {
        return this.formGroup.get('priority');
    }

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(private _formBuilder: FormBuilder, public dialogRef: MatDialogRef<EngageScheduleFeaturedContentDialogComponent>, public audienceService: AudienceService) {}

    ngOnInit(): void {
        this._formGroup = this._formBuilder.group({
            startDate: [this.minDate, Validators.required],
            endDate: [this.maxDate, Validators.required],
            priority: ['high', Validators.required],
        });

        if (this.scss) {
            this._formGroup.patchValue({
                startDate: this.scss.startDate,
                endDate: this.scss.endDate,
                priority: this.scss.priority,
            });
        }

        if (this._formGroup.get('endDate').value) {
            this.showEndDate = true;
            this._formGroup.get('endDate').setValidators(Validators.required);
        }
    }

    toggleEndDate(event: any) {
        this.showEndDate = event.checked;

        const endDateControl = this._formGroup.get('endDate');

        if (this.showEndDate) {
            endDateControl.setValidators(Validators.required);
        } else {
            endDateControl.clearValidators();
            endDateControl.setValue(null);
        }

        endDateControl.updateValueAndValidity();
    }

    async onAddNewAudience() {
        this.dialogRef.close();
    }

    async onScheduleDate() {
        let formData = this.formGroup.getRawValue();
        this.dialogRef.close({ data: formData });
    }
}
